module.exports = __webpack_public_path__ + "img/xsfx.png";